import React from "react";
import { Redirect } from "react-router-dom";
import Auth from "@/Auth/Auth";
import Cookies from 'universal-cookie';

export const Home = () =>
{
    const publicWebUserData = Auth.getPublicWebUserData();
    const isSubscribed = Auth.isSubscribed();
    const isPromotioned = Auth.isPromotioned();
    const cookies = new Cookies();
    const initialRoute = cookies.get("initialRoute");

    if(initialRoute !== undefined)
    {
        cookies.remove("initialRoute", {path: "/"});
        return <Redirect to={initialRoute} />;
    }

    return (
        <React.Fragment>
            {isSubscribed && <Redirect to="/portfolio"/>}
            {!isSubscribed && isPromotioned && <Redirect to="/promotioned"/>}
            {!isSubscribed && !isPromotioned && <Redirect to="/savingsPlans/new"/>}
            {/* Usuarios que vienen del alta desde la web pública con Status 4000.
                lastContractActive es el id del plan de cartera: lo llevamos al mapa nuevo,
                que resuelve el paso vía onboardingState. Si el mapa no puede cargarse, ya
                muestra su propio mensaje de error de fallback. */}
            {publicWebUserData?.status! && publicWebUserData?.lastContractActive! &&
            (
                <Redirect to=
                {{
                    pathname: "/configurationMap",
                    state: { savingPlanId: publicWebUserData.lastContractActive },
                }} />
            )}
        </React.Fragment>
    );
};